module.exports = __webpack_public_path__ + "static/media/Bear Territory_1c.c8dc8778.svg";